//Core
import React, {FC} from "react"
//Styles
import {FlexColumn, FlexBox} from "@/styles/layout/boxes"
import {useSideBarBottomMenu} from "./useSideBarBottomMenu";
import {SupportButton} from "./SideBarBottomMenu.styles";
import {SideBarText} from "../../SideBar.styles";
//Components
import UserInfo from "./user/UserInfo";

//TODO: Add FAQ and Support button when UI will be ready
const SideBarBottomMenu: FC = () => {
    const {
        // openPage,
        isSupportPage,
        // isFAQPage,
        isAuthenticated,
        mixpanelClickSupport
    } = useSideBarBottomMenu();

    return (
        <FlexColumn mt={'auto'} pb={'2rem'}>
            {isAuthenticated && <UserInfo/>}
            <FlexBox>
                <SupportButton active={isSupportPage} onClick={mixpanelClickSupport}>
                    <SideBarText>
                        <a href={'mailto:support@web3m.io'}>
                        {'Support'}
                        </a>
                    </SideBarText>
                </SupportButton>
                {/*<Typography variant={'body2'} color={'#FFFFFF'}>{'|'}</Typography>*/}
                {/*<SupportButton onClick={() => openPage('faq')} active={isFAQPage}>*/}
                {/*    <SideBarText>*/}
                {/*        {'FAQ'}*/}
                {/*    </SideBarText>*/}
                {/*</SupportButton>*/}
            </FlexBox>
        </FlexColumn>
    )
}

export default SideBarBottomMenu